import { config } from "../../../config"
import React, { useState } from 'react';
import { useDispatch } from "react-redux";

import { getLogo } from "../../../layouts/layout";

import {
    Alert,
    FormGroup,
    Form,
    Row,
    Col,
    Input,
    Button
} from 'reactstrap';

// import img1 from '../../../assets/images/logo-icon-tcs.png';
import img2 from '../../../assets/images/big/auth-bg.jpg';
import { deviceApi } from '../../identity/reducers/identitySlice';

const sidebarBackground = {
    backgroundImage: "url(" + img2 + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center"
};

const NewConfirmation = () => {
    const [email, setEmail] = useState("");
    const [showForm, setShowForm] = useState(true);
    const dispatch = useDispatch();

    const onEmailChange = (event) => {
        setEmail(event.target.value);  
    }

    const doConfirmationRequest = (event) => {
        dispatch( deviceApi.getNewConfirmationCode(email) );
        setShowForm(false);
        event.preventDefault();
    }

    return <div className={config.instance.id} id={config.instance.id}>
        {/*--------------------------------------------------------------------------------*/}
        {/*Recover Password Cards*/}
        {/*--------------------------------------------------------------------------------*/}
        <div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
            <div className="auth-box">
                <div id="loginform">
                    <div className="logo">
                        <span className="db"><img src={getLogo()} alt="logo" width="40" height="40" /></span>
                        <h5 className="font-medium mb-3">New confirmation code</h5>
                        <p>
                            Insert your account email and press <b>REQUEST CODE</b> button. 
                            We will send you an email with the new confirmation code.
                        </p>
                    </div>
                    <Row>
                        <Col xs="12">
                            {showForm
                                ? <Form className="mt-3" id="loginform" action="/">
                                    <FormGroup>
                                        <Input 
                                            type="text" 
                                            name="email" 
                                            bsSize="lg" 
                                            id="confirmation_code" 
                                            placeholder="your account email..." 
                                            required 
                                            value={email}
                                            onChange={onEmailChange} />
                                    </FormGroup>
                                    <Row className="mb-4">
                                        <Col xs="12">
                                            <Button color="primary" size="lg" type="submit" className="text-uppercase" block onClick={(event) => doConfirmationRequest(event)}>Request code</Button>
                                        </Col>
                                    </Row>
                                </Form>
                                : <Alert>
                                    Check your inbox, a new confirmation has been code sent to <b>{email}</b>.
                                </Alert>
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>;
}

export default NewConfirmation;
